import React, { useEffect, useState } from 'react'
import CheckboxField from 'components/Checkbox'
import Input from 'components/Input'
import { filterValues } from 'Helper'
import { withTranslation } from 'react-i18next'
import { Loading } from 'components/Btn'
import useSWR from 'swr'
import { useFormContext } from 'react-hook-form'

export default withTranslation()(function AddCashback({ t, getValues }) {
  const { data: Branches } = useSWR('merchants/branches')
  const [branches, setBranches] = useState(null)
  useEffect(() => {
    if (Branches?.data) setBranches(Branches.data)
  }, [Branches]);

  const { reset, watch } = useFormContext()
  useEffect(() => {
    reset({
      ...watch(),
      is_fixed: false
    })
  }, [reset,watch])
  
  const fields = [
    {
      name: 'branch_id',
      label: t('settings.cashback.select'),
      options: Branches?.data ? filterValues({ options: Branches.data.data, param: { value: 'id', label: 'name' } }) : [],
      error: 'required'
    },
    [
      {
        name: 'start',
        label: t('settings.cashback.start'),
        placeholder: '1000',
        error: 'number'
      },
      {
        name: 'end',
        label: t('settings.cashback.end'),
        placeholder: '2000', error: 'number'
      }
    ],
    [
      {
        name: 'is_fixed',
        label: t('settings.cashback.fixed'),
        checkbox: true
      },
      {
        name: 'bonus_percentage',
        label: t('settings.cashback.bonus'),
        placeholder: '10%', error: 'required'
      }
    ],
    {
      name: 'fixed_bonus',
      label: t('settings.cashback.fixed_bonus'),
      placeholder: '400', error: 'required'
    },
  ]
  return (
    <>
      {
        !branches ? (
          <div className="w-full p-1 m-auto flex justify-center items-center">
            <Loading
              classList="h-5 w-5 mr-2"
            />
            <span className="text-md">Loading, Please wait...</span>
          </div>
        ) : (
          fields.map((field, index) => {
            return (
              <React.Fragment key={index.toString()}>
                {
                  field.length ? (
                    <div className="grid md:grid-cols-2 gap-5">
                      {
                        field.map((singleField, nestedIndex) => {
                          return (
                            <div className="mb-4" key={singleField.name}>
                              {
                                singleField.checkbox ? (
                                  <div className="mb-2 md:pt-8">
                                    <CheckboxField
                                      name={singleField?.name}
                                      label={singleField.label}
                                      required

                                    />
                                  </div>
                                ) : (
                                  <React.Fragment key={`nested_index_${nestedIndex}`}>
                                    <Input
                                      name={singleField.name}
                                      label={singleField.label}
                                      placeholder={singleField.placeholder}
                                      disabled={singleField.name !== 'bonus_percentage' ? false : getValues('is_fixed')}
                                      required
                                      error={singleField.error}
                                    />
                                  </React.Fragment>
                                )
                              }
                            </div>
                          )
                        })
                      }
                    </div>
                  ) : (
                    <div className="mb-4">
                      {
                        field.options ? (
                          <Input
                            name={field.name}
                            label={field.label}
                            variant="filled"
                            options={field.options}
                            required
                            error={field.error}
                          />
                        ) : (
                          <Input
                            name={field.name}
                            label={field.label}
                            placeholder={field.placeholder}
                            variant="filled"
                            disabled={field.name !== 'fixed_bonus' ? false : !getValues('is_fixed')}
                            required
                            error={field.error}
                          />
                        )
                      }
                    </div>
                  )
                }
              </React.Fragment>
            )
          })
        )
      }
    </>
  )
})
